"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogTag = exports.fakeConsole = void 0;
function noop() { }
// 非 debug 模式下不需要打印日志
const fakeConsole = {};
exports.fakeConsole = fakeConsole;
Object.keys(console).forEach((fnName) => {
    fakeConsole[fnName] = noop;
});
// 日志流程标记
class LogTag {
    constructor(baseMessage) {
        this.base = `${baseMessage}\n`;
    }
    get begin() {
        return `begin: ${this.base}`;
    }
    get init() {
        return `onInit: ${this.base}`;
    }
    get data() {
        return `onData: ${this.base}`;
    }
    get end() {
        return `onEnd: ${this.base}`;
    }
    get error() {
        return `onError: ${this.base}`;
    }
}
exports.LogTag = LogTag;
